import * as ListVehiclesWaitHappy from './list';
import * as DetailVehiclesWaitHappy from './detail';
import * as UpdateWaitHappy from './update';
import * as DowloadWaitHappy from './excel';

const Actions = {
  ...ListVehiclesWaitHappy,
  ...DetailVehiclesWaitHappy,
  ...UpdateWaitHappy,
  ...DowloadWaitHappy,
};

export default Actions;

